import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import NavBar from '../../Components/NavBar/navbar';
import './Auth.css';
import { API_ENDPOINTS } from '../../utils/config';

const MIN_PASSWORD_LENGTH = 8;

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!token) {
      setError('Missing reset token. Open the link from your email.');
      return;
    }
    if (password.length < MIN_PASSWORD_LENGTH) {
      setError(`Password must be at least ${MIN_PASSWORD_LENGTH} characters`);
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINTS.RESET_PASSWORD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        setSuccess(data.message || 'Password updated. You can sign in.');
        setTimeout(() => navigate('/auth/login'), 2500);
      } else {
        setError(data.error || 'Could not reset password.');
      }
    } catch (err) {
      console.error('Reset-password request failed:', err);
      setError('Server not responding. Try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <NavBar />
      <div className="auth-page-main">
        <div className="auth-container">
          <div className="auth-box">
            <div className="auth-brand">
              Evolv<span>e<sup>x</sup></span>
            </div>
            <h2>Set new password</h2>
            <p className="auth-subtitle">Choose a new password for your EvolveX account</p>

            {error && <div className="auth-error">{error}</div>}
            {success && <div className="auth-success">{success}</div>}

            {!token && !success && (
              <div className="auth-error">
                Missing reset token. Request a new link from{' '}
                <Link to="/forgot-password">Forgot password</Link>.
              </div>
            )}

            {token && !success && (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="password">New password</label>
                  <input
                    id="password"
                    type="password"
                    name="password"
                    autoComplete="new-password"
                    required
                    minLength={MIN_PASSWORD_LENGTH}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={`At least ${MIN_PASSWORD_LENGTH} characters`}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirm password</label>
                  <input
                    id="confirmPassword"
                    type="password"
                    name="confirmPassword"
                    autoComplete="new-password"
                    required
                    minLength={MIN_PASSWORD_LENGTH}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                  />
                </div>

                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Updating…' : 'Update password'}
                </button>
              </form>
            )}

            <p className="auth-footer">
              <Link to="/auth/login">Sign in</Link>
              {' · '}
              <Link to="/forgot-password">Request a new link</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
